module.exports = __webpack_public_path__ + "static/2-large-902bd8d887c0a4ac5ea945ed2e21f7e4.jpg";